import Lmain from '../assests/L-main.png';
import Lmessage from '../assests/L-messages.png';
import Lmusic from '../assests/L-music.png';
import Lpost from '../assests/L-post.png';
import Lprofile from '../assests/L-profile.png';
import Lsignup from '../assests/L-signup.png';
import LbeforeLogin from '../assests/L-welcome.png';
import Salbum from '../assests/Spotify-album.png';
import Shome from '../assests/Spotify-home.png';
import Sliked from '../assests/Spotify-liked.png';
import Ssearch from '../assests/Spotify-search.png';
import lexy from '../assests/lexySpaceLogo.png';
import recoilLogo from '../assests/recoil.png';
import Pscreen1 from '../assests/screen1.png';
import Pscreen2 from '../assests/screen2.png';
import Pscreen3 from '../assests/screen3.png';
import Pscreen4 from '../assests/screen4.png';

export const beforeLogin = LbeforeLogin;
export const main = Lmain;
export const post = Lpost;
export const profile = Lprofile;
export const signup = Lsignup;
export const message = Lmessage;
export const music = Lmusic;
export const home = Shome;
export const album = Salbum;
export const search = Ssearch;
export const liked = Sliked;
export const screen1 = Pscreen1;
export const screen2 = Pscreen2;
export const screen3 = Pscreen3;
export const screen4 = Pscreen4;
export const spotifyLogo =
  'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Flogosmarcas.net%2Fwp-content%2Fuploads%2F2020%2F09%2FSpotify-Logo.png&f=1&nofb=1&ipt=4be9ecd5de8e93f1b7f60949b53b5bf2810e9b468b2d2b8361ce72c0db8a2c73&ipo=images';
export const lexySpaceLogo = lexy;
export const portfolioLogo =
  'https://cdn1.iconfinder.com/data/icons/business-finance-184/512/pie_chart_investment_portfolio_business-512.png';
export const thePillar =
  'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fstatic.vecteezy.com%2Fsystem%2Fresources%2Fpreviews%2F000%2F399%2F588%2Foriginal%2Fred-coming-soon-neon-icon-vector.jpg&f=1&nofb=1';

// Download CV
export const download = 'https://img.icons8.com/ios/50/ffffff/circled-down.png';

// Expand Mode
export const expand =
  'https://img.icons8.com/ios/50/000000/resize-diagonal--v1.png';
export const compress = 'https://img.icons8.com/ios/50/000000/compress--v1.png';

export const expandDark =
  'https://img.icons8.com/ios/50/ffffff/resize-diagonal--v1.png';
export const compressDark =
  'https://img.icons8.com/ios/50/ffffff/compress--v1.png';

// Portfolio Icon
export const portfolioIcon =
  'https://img.icons8.com/ios-filled/50/000000/investment-portfolio.png';
export const portfolioIconDark =
  'https://img.icons8.com/ios-filled/50/ffffff/investment-portfolio.png';
export const myGitHubIcon =
  'https://avatars.githubusercontent.com/u/86908505?v=4';

// Light
export const enterHomeBg =
  'https://res.cloudinary.com/teepublic/image/private/s--ogATTcrp--/t_Resized%20Artwork/c_fit,g_north_west,h_954,w_954/co_ffffff,e_outline:48/co_ffffff,e_outline:inner_fill:48/co_ffffff,e_outline:48/co_ffffff,e_outline:inner_fill:48/co_bbbbbb,e_outline:3:1000/c_mpad,g_center,h_1260,w_1260/b_rgb:eeeeee/c_limit,f_auto,h_630,q_90,w_630/v1541681513/production/designs/3466409_0.jpg';
export const helloGif =
  'https://static.wixstatic.com/media/ac1489_f0adce102cd14a649dcc3349e8cfef43~mv2.gif';
export const sunIcon = 'https://img.icons8.com/ios/50/ffffff/sun--v1.png';
export const sunIconDark = 'https://img.icons8.com/ios/50/000000/sun--v1.png';
export const moonIcon =
  'https://img.icons8.com/ios-filled/50/000000/moon-man.png';
export const moonIconDark =
  'https://img.icons8.com/ios-filled/50/ffffff/moon-man.png';
export const handArrow = 'https://image.pngaaa.com/625/1482625-middle.png';
export const loader =
  'https://media4.giphy.com/media/2Wf4qYgMmou4zjg9qX/giphy.gif?cid=6c09b952isa001wpz45qub9fbcet36e67xktnd83p867ct3h&rid=giphy.gif&ct=s';

// NavBar Icons Light Mode
export const homeIcon = 'https://img.icons8.com/ios/50/000000/home--v3.png';
export const aboutMeIcon = 'https://img.icons8.com/ios/50/000000/user--v1.png';
export const eductionIcon =
  'https://img.icons8.com/ios/50/000000/university.png';
export const workExpIcon = 'https://img.icons8.com/ios/50/000000/new-job.png';
export const resumeIcon =
  'https://img.icons8.com/ios/50/000000/parse-from-clipboard.png';
export const projectsIcon =
  'https://img.icons8.com/ios/50/000000/under-computer.png';
export const contactIcon =
  'https://img.icons8.com/ios/50/000000/filled-message.png';

// Dark Mode
export const homeIconDark = 'https://img.icons8.com/ios/50/ffffff/home--v3.png';
export const aboutMeIconDark =
  'https://img.icons8.com/ios/50/ffffff/user--v1.png';
export const eductionIconDark =
  'https://img.icons8.com/ios-filled/50/ffffff/university.png';
export const workExpIconDark =
  'https://img.icons8.com/ios/50/ffffff/new-job.png';
export const resumeIconDark =
  'https://img.icons8.com/ios/50/ffffff/parse-from-clipboard.png';
export const projectsIconDark =
  'https://img.icons8.com/ios/50/ffffff/under-computer.png';
export const contactIconDark =
  'https://img.icons8.com/ios/50/ffffff/filled-message.png';

// NavBar - Connect
export const linkedIn = 'https://img.icons8.com/ios/50/000000/linkedin.png';
export const github = 'https://img.icons8.com/ios-filled/50/000000/github.png';
export const instagram =
  'https://img.icons8.com/ios-filled/50/000000/instagram-new--v1.png';

// NavBar - Connect Dark Mode
export const linkedInDark = 'https://img.icons8.com/ios/50/ffffff/linkedin.png';
export const githubDark =
  'https://img.icons8.com/ios-filled/50/ffffff/github.png';
export const instagramDark =
  'https://img.icons8.com/ios-filled/50/ffffff/instagram-new--v1.png';

//Skill icons
export const react: string =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/reactjs.svg';
export const javascript =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/javascript.svg';
export const typescript =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/typescript.svg';
export const redux =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/redux.svg';
export const nodeJS =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/nodejs.svg';
export const css =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/css.svg';
export const scss =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/sass.svg';
export const html =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/html.svg';
export const git =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/git.svg';
export const gitHub =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/github.svg';
export const express =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/express.svg';
export const recoil = recoilLogo;
export const mongoDB =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/mongodb.svg';
export const postgreSQL =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/postgresql.svg';
export const restApis =
  'https://alexanderfo.com/wp-content/uploads/2019/12/1139px-Cloud-API-Logo.svg_.png';
export const npm =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/npm.svg';
export const docker =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/docker.svg';
export const heroku =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/heroku.svg';
export const bootstrap =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/bootstrap.svg';
export const aws =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/aws.svg';
export const postman =
  'https://raw.githubusercontent.com/rahulbanerjee26/githubAboutMeGenerator/main/icons/postman.svg';
export const graphQL =
  'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fuxwing.com%2Fwp-content%2Fthemes%2Fuxwing%2Fdownload%2Fbrands-and-social-media%2Fgraphql-icon.png&f=1&nofb=1&ipt=ad1e33cdd3b13fc6b29d6927870ae0c0b46a1f7b4735b4fa3e10c3edc3684edd&ipo=images';
export const dynamoDB =
  'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fredash.io%2Fassets%2Fimages%2Ftemp%2FAmazonDynamoDB.png&f=1&nofb=1';
export const awsAmplify =
  'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fimages.prismic.io%2Fionicframeworkcom%2Fd3576c2287f6fd34c80c31bccf81cd3149dafc08_aws-amplify.png%3Fauto%3Dcompress%2Cformat&f=1&nofb=1';
export const vsCode =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Visual_Studio_Code_1.18_icon.svg/1028px-Visual_Studio_Code_1.18_icon.svg.png';

// Background switch icons
export const animatedNatureIcon =
  'https://img.icons8.com/ios/50/ffffff/deforestation.png';
export const animatedNatureDarkIcon = animatedNatureIcon.replace(
  'ffffff',
  '000000'
);
export const squareIcon =
  'https://img.icons8.com/ios-filled/100/ffffff/squared-menu.png';
export const squareIconDark = squareIcon.replace('ffffff', '000000');
export const triangleIcon =
  'https://img.icons8.com/external-basicons-line-edtgraphics/50/ffffff/external-abstract-abstract-basicons-line-edtgraphics-41.png';
export const triangleIconDark = triangleIcon.replace('ffffff', '000000');
export const icon = 'https://img.icons8.com/ios-filled/50/ffffff/forest.png';
export const iconDark = icon.replace('ffffff', '000000');
export const gtaIcon =
  'https://img.icons8.com/ios/50/ffffff/grand-theft-auto-v.png';
export const gtaIconDark = gtaIcon.replace('ffffff', '000000');
